import React, { Component } from 'react';
import { Result, Button, Typography, Space } from 'antd';
import { ToolOutlined, ReloadOutlined } from '@ant-design/icons';

const { Paragraph, Text } = Typography;

class UnderDevelopment extends Component {
  render() {
    return (
      <div className="under-development-container">
        <Result
          icon={<ToolOutlined style={{ fontSize: 72, color: '#1677ff' }} />}
          title="Under Development"
          subTitle="This page is currently under construction and will be available soon."
        >
        </Result>
      </div>
    );
  }
}

export default UnderDevelopment;